import React, { useState } from "react";
import Reaptcha from 'reaptcha';

import useForm from "../hooks/useForm"
import useMobileChecker from "../hooks/useMobileChecker"

import FormGroup from "./FormGroup"

export const Form = () => {
  const { values, handleChange } = useForm({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const { name, email, subject, message } = values;

  const [captchaLoaded, setCaptchaLoaded] = useState(false);
  const [recaptchaValid, setRecaptchaValid] = useState(false);
  const [error, setError] = useState("");
  const isMobile = useMobileChecker();

  const recaptchaError = "ERROR: Please complete the reCAPTCHA.";

  function handleSubmit(ev) {
    if (!name || !email || !message) {
      ev.preventDefault();
    }
    else if (!recaptchaValid) {
      ev.preventDefault();
      setError(recaptchaError);
    }
  }

  function recaptchaLoaded() {
    setCaptchaLoaded(true);
  }

  function verifyRecaptcha() {
    setRecaptchaValid(true);
    setError("");
  }

  function expiredRecaptcha() {
    setRecaptchaValid(false);
    setError(recaptchaError);
  }

  return (
    <form 
      acceptCharset="UTF-8" 
      action="https://usebasin.com/f/8f6293132f2e"
      onSubmit={handleSubmit}
      name="contact" 
      className="c-form__container" 
      method="POST"
      autoComplete="off"
    >
      <FormGroup
        name="name"
        type="text"
        onChange={handleChange}
        value={name}
      />

      <FormGroup
        name="email"
        type="email"
        onChange={handleChange}
        value={email}
      />

      <FormGroup
        name="subject"
        type="text"
        onChange={handleChange}
        value={subject}
      />

      <FormGroup
        name="message"
        type="textarea"
        onChange={handleChange}
        value={message}
      />
      
      <div className="c-form__group">
        { error && <p className="c-form__error">{error}</p> }
        {
          // Display an empty div until captcha loaded
          !captchaLoaded && <div className="c-form__empty-div"></div>
        }
        <Reaptcha
          sitekey="6Lew3SMUAAAAAJ82QoS7gqOTkRI_dhYrFy1f7Sqy"
          className="c-form__recaptcha"
          onVerify={verifyRecaptcha}
          onError={expiredRecaptcha}
          onLoad={recaptchaLoaded}
          inject={false}
          size={ isMobile ? "compact" : "normal" }
          theme="light"
        />
        <button className="c-button c-form__submit" type="submit">send</button>
      </div>
      
      <input type="hidden" name="hero_net"></input>
    </form>
  )
};